<template>
    <v-layout wrap align-center>
        <template v-if="editable" row>
            <v-flex xs5>
                <time-picker-text-field v-model="hours" :disabled="disabled" :times-list="hoursList" />
            </v-flex>
            <v-spacer />
            <v-flex text-center align-self-center> ： </v-flex>
            <v-spacer />
            <v-flex xs5>
                <time-picker-text-field v-model="minutes" :disabled="disabled" :times-list="minutesList" />
            </v-flex>
        </template>
        <template v-else>
            <v-flex key="disabled" class="label-for-input-form">
                <label class="pa-1">{{ hours }} : {{ minutes }}</label>
            </v-flex>
        </template>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import TimePickerTextField from './TimePickerTextField.vue';
import { AppContext } from '../../store/context';
const TimesList = AppContext.TimesList;

@Component({
    name: 'TimeField',
    components: {
        TimePickerTextField,
    },
})
export default class TimeField extends Vue {
    @Prop({ default: '00:00' }) readonly value: string;
    @Prop({ default: false }) readonly disabled: boolean;
    @Prop({ default: true }) readonly editable: boolean;

    readonly hoursList = TimesList.HOURS;
    readonly minutesList = TimesList.MINUTES;

    @Emit()
    public input(value: string) {}

    /**
     * getter, setter
     */
    get hours(): string {
        return this.value.split(':')[0];
    }
    get minutes(): string {
        const splitted = this.value.split(':');
        if (splitted.length < 2) {
            return '';
        }
        return splitted[1];
    }
    set hours(val: string) {
        this.input(`${val}:${this.minutes}`);
    }
    set minutes(val: string) {
        this.input(`${this.hours}:${val}`);
    }
}
</script>
